import { createAction, props } from '@ngrx/store';
import {
  IDefaultUser,
  IDepartmentReceivers,
  IInfo,
  ILookFeelConfig,
  IUserConfirmationV3,
  IUserLoginConfirmation,
  IUserV3
} from '../models/users.interface';

import { IProcessV3 } from '@literax/components/platform/profiles/types/user-ptofiles';
import { IPatch } from '@literax/models/http/api/client/client.model';
import { IAPIResponseError } from '@literax/models/http/api/error.model';
import { IAuthLogin } from '@literax/models/http/auth/login.model';
import {
  IPaginationV3,
  IQueryParameters
} from '@literax/models/pagination.model';
import { IProfile } from '../../profiles/models/profiles';
import { UserKindEnum } from '../enums/user-kind.enum';

// V3 get all users action
export const getAllUsersV3 = createAction(
  '[Users Component] getAllUsersV3',
  props<{ payload?: IQueryParameters }>()
);

export const getAllUsersV3Success = createAction(
  '[Users Component] getAllUsersV3Success',
  props<{ payload: { usersV3: IUserV3[]; paginationV3: IPaginationV3 } }>()
);

export const getAllUsersV3Error = createAction(
  '[Users Component] getAllUsersV3Error',
  props<{ payload: IAPIResponseError }>()
);

export const errorConf = createAction(
  '[Users Component] errorConf',
  props<{ error: IAPIResponseError }>()
);

export const errorloginConf = createAction(
  '[Users Component] errorloginConf',
  props<{ error: IAPIResponseError }>()
);

// V3 update actions
export const updateUsersV3ById = createAction(
  '[Users Component] updateUsersV3ById',
  props<{ clientUserId: number; patchOperations: IPatch[] }>()
);
export const updateUsersV3ByIdSuccess = createAction(
  '[Users Component] updateUsersV3ByIdSuccess'
);
export const updateUsersV3ByIdError = createAction(
  '[Users Component] updateUsersV3ByIdError',
  props<{ error: IAPIResponseError }>()
);

// V3 delete actions
export const deleteUsersV3 = createAction(
  '[Users component] deleteV3',
  props<{ clientUserId: number }>()
);
export const deleteUsersV3Success = createAction(
  '[Users component] deleteV3Success'
);
export const deleteUsersV3Error = createAction(
  '[Users component] deleteV3Error',
  props<{ error: IAPIResponseError }>()
);

// V3 save actions
export const saveUsersV3 = createAction(
  '[Users Component] saveUsersV3',
  props<{ user: IUserV3 }>()
);
export const saveUsersV3Success = createAction(
  '[Users Component] saveUsersV3Success'
);
export const saveUsersV3Error = createAction(
  '[Users Component] saveUsersV3Error',
  props<{ error: IAPIResponseError }>()
);

export const getUserProfiles = createAction(
  '[Users Component] GetUserProfiles'
);

export const getUserProfilesSuccess = createAction(
  '[Users Component] GetUserProfilesSuccess',
  props<{ payload: { profiles: IProfile[] } }>()
);

export const registerClientUsersConfirmationsV3 = createAction(
  '[Users Component] registerClientUsersConfirmationsV3',
  props<{ user: IUserConfirmationV3; token: string }>()
);
export const registerClientUsersConfirmationsV3Sucess = createAction(
  '[Users Component] registerClientUsersConfirmationsV3Sucess'
);
export const registerClientUsersConfirmationsV3Error = createAction(
  '[Users Component] registerClientUsersConfirmationsV3Error',
  props<{ error: IAPIResponseError }>()
);

export const loginClientUsers = createAction(
  '[Users Component] loginClientUsers',
  props<{
    user: IAuthLogin;
    token: string;
    clientUserJoin: IUserLoginConfirmation;
  }>()
);

export const loginClientUsersConfirmations = createAction(
  '[Users Component] loginClientUsersConfirmations',
  props<{ user?: IUserLoginConfirmation; token: string; b2cToken?: string }>()
);
export const loginClientUsersConfirmationsSucess = createAction(
  '[Users Component] loginClientUsersConfirmationsSucess'
);

export const GetInfo = createAction(
  '[User] GetInfo',
  props<{ payload: string }>()
);

export const GetInfoSuccess = createAction(
  '[User] GetInfoSuccess',
  props<{ payload: { info: IInfo } }>()
);

export const GetInfoError = createAction(
  '[User] GetInfoError',
  props<{ error: IAPIResponseError }>()
);

export const GetLookFeelSuccess = createAction(
  '[User] GetLookFeelSuccess',
  props<{ payload: { lookFeel: ILookFeelConfig } }>()
);

export const ResetPage = createAction('[User] ResetPage');

export const SetDefaultUser = createAction(
  '[User] SetDefaultUser',
  props<{ payload: IDefaultUser }>()
);
export const SetDefaultUserSuccess = createAction(
  '[User] SetDefaultUserSuccess'
);

export const changeSortColumn = createAction(
  '[User] changeSort',
  props<{ payload: string }>()
);

export const changeUserKindFilter = createAction(
  '[User] changeUserKindFilter',
  props<{ payload: UserKindEnum }>()
);

// V3 Dashboard actions
export const getUsersDashboardV3 = createAction('[User] getUsersDashboardV3');
export const getUsersDashboardV3Success = createAction(
  '[User] getUsersDashboardV3Success',
  props<{ payload: IProcessV3 }>()
);
export const getUsersDashboardV3Error = createAction(
  '[User] getUsersDashboardV3Error',
  props<{ payload: IAPIResponseError }>()
);

export const DisableTaxMessage = createAction('[User] DisableTaxMessage');
export const DisableTaxMessageSuccess = createAction(
  '[User] DisableTaxMessageSuccess'
);
export const DisableTaxMessageError = createAction(
  '[User] DisableTaxMessageError',
  props<{ payload: IAPIResponseError }>()
);

export const getReceivers = createAction(
  '[Users] getReceivers',
  props<{ excludeOneself?: boolean }>()
);

export const getReceiversSuccess = createAction(
  '[Users] getReceiversSuccess',
  props<{ payload: { departmentReceivers: IDepartmentReceivers[] } }>()
);
